<template>
<div>
   
<table class="table table-sm table-striped table-hover">
    <thead class="detail_">

    <tr :style="{backgroundColor : '#FFFF99',color: 'blue' ,fontSize:  '15px',fontWeight:'bold' }" >
        <th>
           Id 
        </th>
        <th>
          Fornitore
        </th>            
        <th>
          Brand
        </th>
        <th>
          Codice prodotto
        </th>
        <th>
          Categoria 
        </th>
        <th>
          Totale   
        </th>
        
        
    </tr>
    </thead>
    <tbody>
    <tr :style="{fontSize:  '14px',fontWeight:'normal' }"  v-for="(item, index) in items" :key="index">
    <td>
        {{item.productId}}
    </td>
    <td>
        {{item.supplier}}
    </td>
    <td>
        {{item.brand}}
    </td>
    <td>
        {{item.sku}}
    </td>
    <td>
        {{item.category}}
    </td>
    <td>
        {{item.qty}}
    </td>
    
    
    
    
    </tr>
    </tbody>
</table>

</div> 
</template>

<script>


export default {
   props: ['items'],
   components: {
  
   
  },
  data () {
    return { 

        color : ['#006600','#990000','#660099'],     
        
       
    }
  },
  computed: 
  {   
    
  },


  created()
  { 
    
  
  },
      
  mounted()
  {},
  methods: 
  {
     
  }
  
}
</script>

<style scoped>
.detail {
    background    : yellow;
    font-family  : 'Roboto Condensed';
    font-size     : 20px;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}
</style>